import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { UnitInfo } from '../../model/UnitInfo.model';


@Component({
  selector: 'app-Unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.css']
})
export class UnitComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _PositionModule: number;

  LoadUnit: UnitInfo[];
  txtSchUnitName: string;
  txtSchUnitCode: string;
  ddlSchPositionStatus: string;
  txtUnitCode: string;
  txtUnitName: string;
  txtExUnitName: string;
  txtExUnitCode: string;
  isOnUpdate: boolean;
  hidUnitId: number;
  element: HTMLElement;
  public hidcouchk: string;

  //Form variable
  positionForm: FormGroup;
  positionInfo: UnitInfo = new UnitInfo;

  //Pagination
  currentPageNumber: number = 1;
  totalPositions: number = 0;
  totalPages: number = 0;
  pageSize: number;
  public UnitTotal: any
  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  // Zone pagination variable
  isSubmitted: any;
  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeSmall;
    this._EmpCode = localStorage.getItem("EmpCode");
    this._PositionModule = ConstVariable.PositionProjectModule; //Project Delivery
    this.ddlSchPositionStatus = ''
    this.LUnit();
    $(document).ready(function () {
      $('#InsertSectionUnit').css('display', 'none');
    });

    //Load init data




    //Declare form
    this.positionForm = new FormGroup({
      //PositionCode: new FormControl(this.positionInfo.PositionCode, [Validators.required]),
      //PositionName: new FormControl(this.positionInfo.PositionName, [Validators.required]),
      //PositionLevel: new FormControl(this.positionInfo.PositionLevel, [Validators.required]),
      //PositionStatus: new FormControl(this.positionInfo.FlagActive),
      //FlagCreate: new FormControl(this.positionInfo.FlagCreate),
      //FlagEdit: new FormControl(this.positionInfo.FlagEdit),
      //FlagDeleteRights: new FormControl(this.positionInfo.FlagDeleteRights),
      //FlagApprove: new FormControl(this.positionInfo.FlagApprove),
      //FlagAssign: new FormControl(this.positionInfo.FlagAssign),
      //FlagView: new FormControl(this.positionInfo.FlagView),
    });
  }

  //get PositionCode() { return this.positionForm.get('PositionCode'); }
  //get PositionName() { return this.positionForm.get('PositionName'); }
  //get PositionLevel() { return this.positionForm.get('PositionLevel'); }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  LUnit() {
    this.LoadListUnit()
      .then(
        data => {
          this.LoadUnit = data
          this.hidcouchk = this.LoadUnit.length.toString();
        }
      )
      .then(() => {
        this.CountUnitList()
      })
  }

  async CountUnitList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{ \"UnitName\": \"" + this.checkUndefinedString(this.txtExUnitName) + "\", " +
        "\"CreateBy\": \"" + this.checkUndefinedString(localStorage.getItem("EmpCode")) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";


      this.httpClient
        .post<UnitInfo[]>(this.baseurl + "Unit/GetCountUnit",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.UnitTotal = data
        })
        .then(() => {
          if (this.UnitTotal == 0) {
            this.currentPageNumber = 1;
          }
          this.totalPages = Math.ceil(this.UnitTotal / environment.PageSize)
        })
    }
  }


  async LoadListUnit(positionId: number = 0): Promise<UnitInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['UnitName'] = this.checkUndefinedString(this.txtSchUnitName);
      objectjson['UnitCode'] = this.checkUndefinedString(this.txtSchUnitCode);
      //objectjson['CompanyCode'] = this.checkUndefinedString(this.txtSearchCompany);
      //objectjson['rowFetch'] = environment.PageSize;
      //objectjson['rowOFFSet'] = offset;
      //objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<UnitInfo[]>(this.baseurl + "Unit/GetUnit", strjson, httpOptions)
        .toPromise()

    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.LoadListUnit().then((data) => {
      this.LoadUnit = data;
    });
  }
  OnClear_Click() {
    this.txtSchUnitName = null;
    this.txtSchUnitCode = null;
    this.txtExUnitName = null;
    this.txtExUnitCode = null;

    this.currentPageNumber = 1;
    this.LoadListUnit().then((data) => {
      this.LoadUnit = data;
    });
  }

  //Create btn
  btnClick_onCreateUnit() {

    $('#InsertSectionUnit').css('display', 'block');

  }
  btnClick_cancel() {
    this.txtSchUnitName = null;
    this.txtSchUnitCode = null;
    this.txtExUnitName = null;
    this.txtExUnitCode = null;
    $('#InsertSectionUnit').css('display', 'none');
  }


  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitlookup").hide();
      $("#txtLookupType").prop('disabled', true);
      $("#txtLookupValue").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitlookup").show();
      $("#txtLookupType").removeAttr('disabled');
      $("#txtLookupValue").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalLookup').modal('hide');
    }
  }


  async btnClick_submitInsertUnit() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnCreating('y');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };



      let strjson = "{" +
        "\"UnitCode\": \"" + this.checkUndefinedString(this.txtExUnitCode) + "\", " +
        "\"UnitName\": \"" + this.checkUndefinedString(this.txtExUnitName) + "\", " +
        "\"CreateBy\": \"" + this.checkUndefinedString(localStorage.getItem("EmpCode")) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";

      this.isSubmitted = this.httpClient.post<LookupInfo[]>(this.baseurl + "Unit/InsertUnit", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
          this.OnCreating('n');
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.OnClear_Click();
            //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

            //Inform user
            this.titlemodal = '';
            this.detailmodal = 'User information has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#InsertSectionUnit').css('display', 'none');
            this.LUnit()
          }
        );
    }
  }

  //Edit Function
  OnEdit_Click(id) {
    $('#InsertSectionUnit').css('display', 'block');
    document.getElementById("AddEditUnit").scrollIntoView();
    this.isOnUpdate = true


    let index = this.LoadUnit.findIndex(x => x.UnitId == id);
    this.hidUnitId = this.LoadUnit[index].UnitId
    this.txtExUnitCode = this.LoadUnit[index].UnitCode
    this.txtExUnitName = this.LoadUnit[index].UnitName

  }
  btnClick_submitUpdateUnit(id) {
    $('#ModalConfirmChanges').modal();
  }
  async confirmSaveChanges() {
    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      $('#InsertSectionUnit').css('display', 'block');
      var id = this.hidUnitId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      if (this.txtExUnitName == undefined || this.txtExUnitName == null || this.txtExUnitName == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }

      else if (this.txtExUnitCode == undefined || this.txtExUnitCode == null || this.txtExUnitCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {

        let objData = {};
        objData["UnitId"] = id;
        objData["UnitCode"] = this.txtExUnitCode;
        objData["UnitName"] = this.txtExUnitName;
        objData["UpdateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<UnitInfo[]>(this.baseurl + "Unit/UpdatUnit", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();
              $('#InsertSectionUnit').css('display', 'none');

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LUnit();
            }
          )
      }
    }
  }


  //Delete Function
  async OnDelete_Click(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{UnitId: " + id + "}";

      if (confirm("Are you sure you want to delete this Unit?")) {
        this.isSubmitted = this.httpClient.post<UnitInfo[]>(this.baseurl + "Unit/DeleteUnit", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Unit information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LUnit();
            }
          )
      }
    }

  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxUnit"]').prop('checked', check);

  }

  async OnDeleteList_Click() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('UnitId' + i);

      if (isChecked) {
        await this.OnDelete_Click(parseInt(element.value));
      }
    }
    //Load new data
    this.LUnit();
  }

  //Name position clicked
  OnAddRights_Click(id) {

  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    this.LoadListUnit().then((data) => {
      this.LoadUnit = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalPositions = data;
    if (this.totalPositions == 0) this.currentPageNumber = 0;
    this.totalPages = Math.ceil(this.totalPositions / environment.PageSize);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
